<template>
  <div class="header" :class="{'bg_black':mobileShow}" >
    <!-- start top-nav-->
      <!--pc端导航-->
      <div class="pc-box" >
        <div class="logo fl"><img src="../assets/img/header/logo.png"></div>
        <div class="wrap fr"  v-show="$route.meta.headerShow">
            <nav-menu :data="navList"></nav-menu>
        </div>
      </div>
      <!--start smart_nav 手机端导航-->
      <div class="mobile-box">
        <div class="bg_fff" v-show="true">
        <div class="logo"><img src="../assets/img/header/logo_black.png"></div>
        </div>
        <transition name="draw fr" >
          <nav-menu-mobile :data="navList" v-show="mobileShow"></nav-menu-mobile>
        </transition>
        <div class="nav-mobile" @click="navToggle"></div>
      </div>
      <!--end smart_nav-->
  </div>
</template>

<script>
  import NavMenuMobile from "./NavMenuMobile/NavMenuMobile";
  import NavMenu from "./NavMenu/NavMenu";
  import {getNavList} from "../network/nav"
  export default {
      name: "MyHeader",
      components: {NavMenuMobile, NavMenu},
      props: {
          currentMenuId: Number
      },
      data() {
          return {
              headerShow:true,
              navList: [],
              navShow: false,
          }
      },
      created() {
          this.getNavList()
      },
      computed: {
          mobileShow() {
              return this.$store.state.mobileNavShow;
          }
      },
      methods: {
          navToggle() {
              if (this.navShow) {
                  this.$store.commit('foldNav');
              } else {
                  this.$store.commit('unFoldNav');
              }
              this.navShow = !this.navShow;
          },
          getNavList() {
              getNavList().then(response => {
                  this.navList = response.data
                  // console.log( response);        })
              })
          }
      }
  }

</script>

<style scoped>

  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    /* padding: 22px 100px; */
    box-sizing: border-box;
    z-index: 998;
  }
  .pc-box {
    text-align: right;
    position: relative;
    width: 100%;
    z-index: 2;
    will-change: height;
    padding: 22px 100px;
  }
  .wrap {
    /*width: 50%;*/
  }
  .pc-box{
    position: relative;
  }

 .pc-box .logo {
    width: 20%;
  }
  .logo>img{
    width: 100%;
  }



  /*-- start-smartphone_nav --*/
  .mobile-box {
    display:none;
  }
  .nav-item a {
    display:block;
  }
  .nav-item a:hover {
    background:#D45B45;
    color: #FFFFFF;
  }
  .nav-mobile {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 11px;
    background: url(../assets/img/header/nav_icon.png) 60% 60% no-repeat;
    height:32px;
    width: 32px;
  }

  .mobile-box {
    width:100%;

  }
  .bg_black{
    background: rgba(0,0,0,.9);
    height: 100%;

  }
  @media only screen and (max-width: 768px) {
    .header{
      padding: 0;
    }
    .pc-box {
      display: none;
    }

    .mobile-box {
      display: block;

    }
  .logo {
      width: 50%;
    padding: 10px;
    }
    .nav-mobile{
      display: block;
      cursor: pointer;
      position: absolute;
      top: 5px;
      right: 10px;
      background: url(../assets/img/header/nav_icon.png) 60% 60% no-repeat;
      height:32px;
      width: 32px;
    }

  }



</style>



// WEBPACK FOOTER //
// src/components/MyHeader.vue